import { useEffect } from "react";
import { useSelector } from "react-redux";
import Grid, { GridJustification } from "@material-ui/core/Grid";
import Chip from "@material-ui/core/Chip";
import {
  setFilterPanelVisibility,
  setInfluenceAreaEnabled,
  setManualFilters,
  setShowIndoorDeviceList,
} from "../../../store/filterStore/filterState";
import { useTypedDispatch } from "../../../app/state";
import { selectInfluenceAreaEnabled } from "../../../store/filterStore/filterSelectors";
import useFilter from "../../../hooks/filter.hook";
import { FilterPanelEnum } from "../../../store/filterStore/filterPanel.enum";

import classes from './index.module.scss';

enum FILTER_CHIP_NAMES {
  'INFLUENCE_AREA',
  'COVERAGE_PARAMETERS',
  'FILTERS',
  'SHOW_INDOOR_DEVICES',
}

type FilterChipProps = {
  justifyContent?: GridJustification,
  positionAbsolute?: boolean,
  chips?: FILTER_CHIP_NAMES[],
}

const FilterChipContainer = ({
  justifyContent = 'flex-start',
  positionAbsolute = true,
  chips =
    [ FILTER_CHIP_NAMES.INFLUENCE_AREA, FILTER_CHIP_NAMES.COVERAGE_PARAMETERS, FILTER_CHIP_NAMES.FILTERS ]
}: FilterChipProps) => {
  const dispatch = useTypedDispatch();
  const { actions, state } = useFilter();
  const {
    smartFiltersChannelList,
    isAnyFilterChosen,
    isManualFiltersPanelVisible,
    isCoveragePanelVisible,
    coverageSettingsAreSet,
    showIndoorDeviceList,
  } = state;
  const influenceAreaEnabled = useSelector(selectInfluenceAreaEnabled);

  useEffect(() => {
    // if device has no channels
    if (smartFiltersChannelList.length === 0) {
      actions.updateSmartFilterDeviceIdList(null)
    }
  }, []);

  const onInfluenceFilterClick = () => {
    dispatch(setInfluenceAreaEnabled(!influenceAreaEnabled));
  }

  const onCoverageClick = () => {
    dispatch(setFilterPanelVisibility(isCoveragePanelVisible ? null : FilterPanelEnum.COVERAGE_OPTIONS));
  }

  const onManualFilterClick = () => {
    dispatch(setFilterPanelVisibility(isManualFiltersPanelVisible ? null : FilterPanelEnum.FILTERS));
  }

  const onShowIndoorDevices = () => {
    dispatch(setShowIndoorDeviceList(!showIndoorDeviceList));
    // clear all manual and smart filters
    actions.updateSmartFilterDeviceIdList(null);
    dispatch(setManualFilters(null))
  }

  const chipElements = [
    // influence area
    (
      <Chip
        label="Influence area"
        color={influenceAreaEnabled ? 'primary' : 'default'}
        onClick={onInfluenceFilterClick}
      />
    ),
    // coverage filters
    (
      <Chip
        label="Coverage settings"
        color={coverageSettingsAreSet ? 'primary' : 'default'}
        onClick={onCoverageClick}
      />
    ),
    // manual filters
    (
      <Chip
        label={!!isAnyFilterChosen ? 'Filtered' : 'Filters'}
        color={!!isAnyFilterChosen ? 'primary' : 'default'}
        onClick={onManualFilterClick}
      />
    ),
    <Chip
      label="Show indoor devices"
      color={showIndoorDeviceList ? 'primary' : 'default'}
      onClick={onShowIndoorDevices}
    />
  ];

  return (
    <Grid
      container
      spacing={2}
      direction="row"
      justifyContent={justifyContent}
      className={positionAbsolute ? classes.absoluteFilters : ''}
    >
      {
        chips.map((chipIndex, index) => <Grid item key={index}>{chipElements[chipIndex]}</Grid>)
      }
    </Grid>
  );
}

FilterChipContainer.FILTER_CHIP_NAMES = FILTER_CHIP_NAMES;

export default FilterChipContainer;
